import { ItemService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const ItemManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return ItemService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (item) => {
    return ItemService.crear(item).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const actualizar = (item) => {
    return ItemService.actualizar(item).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const buscarPorId = (id) => {
    return ItemService.buscarPorId(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  return { listado, crear, actualizar, buscarPorId };
})();